// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"320px","tabletWidth":"1024px","desktopWidth":"1440px","largeDesktopWidth":"1600px"};